import { api, unwrap } from "./client";
import type { components } from "./schema";

export type PublicTrafficRankingSnapshot =
	components["schemas"]["PublicTrafficRankingSnapshot"];

export async function fetchPublicTrafficRankingSnapshot(
	snapshotId: string,
): Promise<PublicTrafficRankingSnapshot> {
	return unwrap(
		await api.GET("/api/v1/public/traffic-ranking-snapshots/{snapshot_id}", {
			params: { path: { snapshot_id: snapshotId } },
		}),
	);
}
